import cf from './cf';
import c70v from './c70v_20220623';

export default class c70v1a extends c70v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.d_viewDefs = {
      class: 'c70v1a',
      name: '祝日一覧',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
